// components/KeyPad.tsx
import React from "react";

interface KeyPadProps {
    onInputChange: (value: string | ((prev: string) => string)) => void;
    handlePayment: () => void;

    selectedPaymentMethod: string; // Adjust type if necessary
    receivedAmount: number;        // Adjust type if necessary
    totalAmount_SST: number;
}

const KeyPad: React.FC<KeyPadProps> = ({ onInputChange, handlePayment, selectedPaymentMethod, receivedAmount, totalAmount_SST }) => {
    const buttons = [
        "1", "2", "3", "+",
        "4", "5", "6", "-",
        "7", "8", "9", "*",
        ".", "0", "=", "/",
        "Backspace", "C",
        // "Pay",
    ];

    const externalButtons = [5, 10, 20, 50, 100, 150, 200]; // External buttons for adding amounts


    const handleButtonClick = (value: string) => {
        if (value === "C") {
            onInputChange("");
        } else if (value === "Backspace") {
            onInputChange((prev) => prev.slice(0, -1)); // Remove the last character
        } else if (value === "=") {
            onInputChange((prev) => {
                try {
                    // Perform calculation
                    const result = eval(prev); // Avoid eval in production; replace with a safer solution
                    return result.toString();
                } catch {
                    return "Error";
                }
            });
        } else if (value === "Pay") {
            // if (!selectedPaymentMethod || receivedAmount <= 0 || receivedAmount <= totalAmount_SST) return;
            if (isPayEnabled)
                handlePayment(); // Call the payment handler
        } else {
            onInputChange((prev) => prev + value); // Append the button value
        }
    };

    const handleExternalButtonClick = (value: number) => {
        // Update receivedAmount with the external button value
        onInputChange((prev) => (parseFloat(prev || "0") + value).toString());
    };

    const isPayEnabled =
        selectedPaymentMethod &&
        receivedAmount > 0 &&
        receivedAmount >= Number(totalAmount_SST.toFixed(2));

    return (
        <div>
            {/* className="w-full flex flex-col justify-center items-center rounded-xl pb-8" style={{ backgroundColor: '#7a75b5' }}> */}

            {/* External buttons */}
            <div className="flex flex-wrap justify-center bg-white rounded-xl mt-2 m-3 p-1 ">
                {externalButtons.map((btn, index) => (
                    <button
                        key={index}
                        onClick={() => handleExternalButtonClick(btn)}
                        className="mx-2 my-1 h-14 w-14 border  border-blue-500 bg-white  text-yellow-600 font-bold rounded-full"
                    >
                        {btn}.00
                    </button>
                ))}
            </div>
            {/* LED Screen */}
            <div className="w-full flex items-center mb-4">
                <button
                    onClick={() => handleButtonClick("Pay")}
                    className={`mx-4  h-14 rounded-full text-xl font-bold shadow-sm border border-1 border-green-400 
                        ${!isPayEnabled
                            ? "w-14 bg-gray-500 text-gray-300 cursor-not-allowed"
                            : "w-14 bg-green-500 text-white"
                        }
                        active:shadow-inner active:opacity-80`}
                    disabled={!isPayEnabled}
                >
                    Pay
                </button>
                <div className="w-2/3 h-16 bg-gray-50 text-green-700 text-right text-3xl p-4 rounded-lg font-mono shadow-md overflow-hidden">
                    {receivedAmount || "0"}
                </div>
            </div>
            <div className="flex flex-col  justify-center">
                <div className="flex justify-center">
                    {/* Keypad */}
                    <div className="flex flex-wrap justify-center w-80">
                        {buttons.map((btn, index) => (
                            <button
                                key={index}
                                onClick={() => handleButtonClick(btn)}
                                className={`mx-2 my-1 h-14 rounded-full text-xl font-bold shadow-sm  border border-1 border-yellow-200 
                ${btn === "Pay"
                                        ? `${!isPayEnabled
                                            ? "w-14 bg-gray-500 text-gray-300 cursor-not-allowed"
                                            : "w-14 bg-green-500 text-white"
                                        }`
                                        : btn === "C"
                                            ? "w-14 bg-red-500 text-white"
                                            : btn === "Backspace"
                                                ? "w-32 bg-yellow-400 text-black"
                                                : btn === "="
                                                    ? "w-14 bg-orange-500 text-white"
                                                    : btn === "null"
                                                        ? "w-1 m-0 bg-transparent text-transparent"
                                                        : "w-14 bg-gray-300 text-black"
                                    }
                active:shadow-inner active:opacity-80`}
                                disabled={btn === "Pay" && !isPayEnabled}
                            >
                                {btn}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default KeyPad;
